__turbopack_context__.v({
  "container": "ContractVerificationPage-module__Dfm6PW__container",
  "form": "ContractVerificationPage-module__Dfm6PW__form",
  "header": "ContractVerificationPage-module__Dfm6PW__header",
  "input": "ContractVerificationPage-module__Dfm6PW__input",
  "section": "ContractVerificationPage-module__Dfm6PW__section",
  "sectionTitle": "ContractVerificationPage-module__Dfm6PW__sectionTitle",
  "select": "ContractVerificationPage-module__Dfm6PW__select",
  "submitButton": "ContractVerificationPage-module__Dfm6PW__submitButton",
  "subtitle": "ContractVerificationPage-module__Dfm6PW__subtitle",
  "textarea": "ContractVerificationPage-module__Dfm6PW__textarea",
  "title": "ContractVerificationPage-module__Dfm6PW__title",
});
